import { Bell, Check, Clock, DollarSign, Image, List, Shield, UserPlus } from "lucide-react"

import { cn } from "@/lib/utils"

// The tone-colored icon chip shared by the bell dropdown (BellMenu) and the full
// Notifications page, so the two surfaces render a notification's glyph + signal
// color identically. `icon` is the presenter's glyph name; `tone` is the signal:
//   info   — neutral (default event)
//   action — red (needs the customer to act)
//   pos    — green (good news)
const GLYPH = {
  check: Check,
  dollar: DollarSign,
  image: Image,
  clock: Clock,
  shield: Shield,
  list: List,
  invite: UserPlus,
  user: UserPlus,
  bell: Bell,
}

const TONE = {
  info: "bg-secondary text-muted-foreground",
  action: "bg-[var(--red-soft)] text-primary",
  pos: "bg-[color-mix(in_oklab,var(--done)_14%,transparent)] text-[var(--done)]",
}

export default function NotifIcon({ icon, tone = "info", size = 40 }) {
  const Glyph = GLYPH[icon] || Bell

  return (
    <span
      className={cn("grid shrink-0 place-items-center rounded-[11px]", TONE[tone] || TONE.info)}
      style={{ width: size, height: size }}
    >
      <Glyph className="size-[18px]" strokeWidth={2} />
    </span>
  )
}
